import type { IToken } from 'chevrotain';

import { getTokenName } from 'bones/utils/queryBuilder/parsing/helpers/getTokenName';
import { sparqlTokens } from 'bones/utils/queryBuilder/parsing/helpers/sparql';

export const getFullIri = (
  token: IToken,
  namespaces: Record<string, string>
) => {
  let iri = '';
  if (getTokenName(token) === sparqlTokens.sparqlTokenMap.IRIREF.name) {
    iri = token.image.slice(1, token.image.length - 1);
  } else {
    const abbreivated = token.image;
    const idx = abbreivated.indexOf(':');
    if (idx !== -1) {
      const abbr = abbreivated.slice(0, idx);
      const prefix = namespaces[abbr];
      if (prefix) {
        iri = `${prefix}${abbreivated.slice(idx + 1)}`;
      }
    }
  }
  return iri;
};
